const normalizeAppEnv = (value) => {
    const raw = String(value || '').trim().toLowerCase();
    if (raw === 'production' || raw === 'prod') return 'production';
    if (raw === 'development' || raw === 'dev') return 'development';
    return '';
};

/**
 * Interruptor de entorno (independiente de NODE_ENV de webpack).
 * En .env: REACT_APP_ENV=development | production
 * Si no está, usa NODE_ENV.
 */
export const APP_ENV = normalizeAppEnv(process.env.REACT_APP_ENV)
    || normalizeAppEnv(process.env.NODE_ENV)
    || 'development';

export const IS_PRODUCTION = APP_ENV === 'production';

const pickEnv = (productionValue, developmentValue, fallback = '') => {
    const raw = IS_PRODUCTION ? productionValue : developmentValue;
    return String(raw || fallback || '').trim();
};

const withTrailingSlash = (url) => {
    if (!url) return url;
    return url.endsWith('/') ? url : `${url}/`;
};

const withoutTrailingSlash = (url) => String(url || '').replace(/\/$/, '');

/** Backend HTTP según REACT_APP_ENV. */
export const API_URL = withTrailingSlash(pickEnv(
    process.env.REACT_APP_API_URL_PRODUCTION,
    process.env.REACT_APP_API_URL_DEV,
    process.env.REACT_APP_API_URL || 'http://localhost:8000/',
));

/** Socket.IO: mismo host que la API salvo que se defina aparte. */
export const SOCKET_URL = withoutTrailingSlash(pickEnv(
    process.env.REACT_APP_SOCKET_URL_PRODUCTION,
    process.env.REACT_APP_SOCKET_URL_DEV,
    process.env.REACT_APP_SOCKET_URL || API_URL,
));
